export default {
  index: '/',
  signUp: '/t',
  signUpSuccess: '/t/success',
  emailPreferences: '/email-preferences',
  ourHistory: '/our-history',
  policies: '/policies',
  privacy: '/policies/privacy',
  policiesSalesTax: '/policies/sales-tax',
  termsConditions: '/terms-conditions',
}
